import React, { useEffect, useState, useCallback } from "react";
import { Skeleton, Dialog, DialogContent, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useParams } from "react-router-dom";
import api from "../../api/api";
import { useDispatch, useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { use } from "react";
import SaveIcon from "../../../src/assets/orders/Save.svg";
import { addIcon, heartIcon, starIcon } from "./svg";
import { setConfig } from "../../reduxtoolkit/userconfigslice";
import dayjs from "dayjs";

const ProceduresNavButtons = ({
  data,
  userdata,
  getordersData,
  selectedCard,
  dt,
  loading,
  fetchsuggestions,
  selectedSuggestionList,
    startDate,
  appointmentId,
}) => {
  const [selectedTabs, setSelectedTabs] = useState([]);
  const [selectedAddTabs, setSelectedAddTabs] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState("");
  const [inputValue, setInputValue] = useState("");
  const [selectedSuggestion, setSelectedSuggestion] = useState("");
  const [isChecked, setIsChecked] = useState(false);
  const [selectedDx, setSelectedDx] = useState("");
  const [selecteddesc, setSelecteddesc] = useState("");
  const [fetcheddata, setFetcheddata] = useState([]);
  const practiseid = window.getPracticeId();
  const dispatch=useDispatch()
 const userConfig = useSelector((state) => state.userconfig);
  const [fetchingDx, setFetchingDx] = useState(false);
  const lovValue = useSelector(
    (state) => state.dump.storedvalues.find((item) => item.id === "lov")?.value
  );
let fav=userConfig.config?.fav_procedures||[]
  const tovValue = useSelector(
    (state) => state.dump.storedvalues.find((item) => item.id === "tov")?.value
  );
  const [searchResults, setSearchResults] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const appointmentInfo = useSelector((state) => state.appinfo.appointmentInfo);
  const RelatedResults = useSelector(
    (state) => state.universalsearcher.searchResults
  );
  useEffect(() => {
    if (
      !Array.isArray(selectedSuggestionList) ||
      selectedSuggestionList.length === 0
    ) {
      setSelectedTabs([]);
      return;
    }

    const selectedIndexes = data
      .map((item, index) =>
        selectedSuggestionList.some(
          (suggestion) => suggestion.ordername === item.content
        )
          ? item.content
          : null
      )
      .filter((index) => index !== null);

    setSelectedTabs(selectedIndexes);
  }, [data, selectedSuggestionList]);

  const handleTabClick = async (itemContent) => {
    const isSelected = selectedTabs.includes(itemContent);

    try {
      if (isSelected) {
        // Call delete API
        const orderToDelete = selectedSuggestionList.find(
          (x) => x.ordername === itemContent
        );

        if (orderToDelete) {
          const deleteResponse = await api.delete(
            `/v1/${practiseid}/orders/delete/order/${orderToDelete.ordre_id}`,
            {
              data: {
                // orderdate:  userdata.created_at?new Date(userdata.created_at).toISOString().split('T')[0]: "Invalid date",
                orderdate:
                  dt && dt.includes(" ") && !isNaN(Date.parse(dt.split(" ")[0]))
                    ? dt.split(" ")[0]
                    : new Date().toISOString().split("T")[0],
              },
            }
          );
          console.log("Delete API Response:", deleteResponse.data);
        } else {
          console.error("Order ID not found for deletion");
        }
      } else {
        const createResponse = await api.post(
          `/v1/${practiseid}/patient/${userdata.patientid}/orders/create`,
          {
            department_id: 1,
            patient_name: `${userdata.firstname || ""} ${
              userdata.lastname || ""
            }`.trim(),
            tov: tovValue, // purpose
            lov: userdata.lov,
            diagnosis: "",
            ordertype: "procedure", // tabs
            ordername: itemContent, // buttons
            schedule: selectedCard, // t/f-schedule
            // provider: userdata.linked_provider,
            provider: `${userConfig?.firstname || ""} ${userConfig?.lastname || ""}`,
            status: "CREATED",
            confirm_status: "E", // C/E
                orderdate:
                    dayjs(dt).isValid()
                      ? dayjs(dt).format("YYYY-MM-DD")
                      : dayjs().format("YYYY-MM-DD"),
            encounterid: 0,
          }
        );
      }

      // Update state after the API call
      setSelectedTabs((prevSelected) => {
        if (isSelected) {
          // Deselect if already selected
          return prevSelected.filter((content) => content !== itemContent);
        } else {
          // Select if not already selected
          return [...prevSelected, itemContent];
        }
      });
      fetchsuggestions();
    } catch (error) {
      console.error("Error in handleTabClick:", error);
    }
  };

  const handleClose = () => {
    setIsModalOpen(false);
  };

  const fetchInitialData = async () => {
    setFetchingDx(true);
    try {
      const response = await api.post(`/v1/${practiseid}/orders/get/lcptdata`, {
        ordername: "ECHO",
        patientid: appointmentInfo.patientid,
        appointment_id: appointmentInfo.appointmentid,
      });
      setFetcheddata(response.lcpts || []);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setFetchingDx(false);
    }
  };

  useEffect(() => {
    if (isModalOpen) {
      fetchInitialData();
    }
  }, [isModalOpen]);
const updateFavLabs = async (lab) => {
  try {
    let updatedFavs = [...fav];
    if (!updatedFavs.includes(lab)) {
      updatedFavs.push(lab);
    }

   const response= await api.put(`/v1/${practiseid}/user/config`, {
      rowid: userConfig.id,
      fav_procedures: updatedFavs,
    });
 if (response.status === 200) {
      // Update Redux state with the new config
      dispatch(setConfig({
        ...userConfig,
        config: {
          ...userConfig.config,
         fav_procedures: updatedFavs,
        },
      }));
    }
    console.log("Fav labs updated:", updatedFavs);
  } catch (error) {
    console.error("Error updating fav labs:", error);
  }
};
const removeFavbutton = async (lab) => {
  try {
    // Create a new array without the lab to remove
    const updatedFavs = fav.filter((l) => l !== lab);

    // Update the server
    const response = await api.put(`/v1/${practiseid}/user/config`, {
      rowid: userConfig.id,
      fav_procedures: updatedFavs,
    });

    if (response.status === 200) {
      // Update Redux state
      dispatch(setConfig({
        ...userConfig,
        config: {
          ...userConfig.config,
          fav_procedures: updatedFavs,
        },
      }));
    }

    console.log("Fav labs updated:", updatedFavs);
  } catch (error) {
    console.error("Error removing fav lab:", error);
  }
};
const handlebuttonclick = async (x) => {
  if (isLoading) return; // Prevent multiple clicks
  isLoading = true;

  try {
    const contentToAdd = x; // Assuming it's a string

    if (!selectedTabs.includes(contentToAdd) &&
        !selectedSuggestionList.some((item) => item.ordername === contentToAdd)) {
      await handleTabClick(contentToAdd);
      selectedTabs.push(contentToAdd);
    }
  } catch (error) {
    console.error("Error in handleStrepFluCovidClick:", error);
  } finally {
    isLoading = false;
  }
};
  const fetchMedicationSuggestions = useCallback(
    debounce(async () => {
      if (inputValue.trim().length > 1) {
        try {
          const response = await api.post(
            `/v1/${practiseid}/orders/patient/${appointmentInfo.patientid}/get/searchlcddiagnostics`,
            {
              searchVal: inputValue,
              patientId: appointmentInfo.patientid,
              order_name: modalContent.content,
              limit: 5,
            }
          );
          if (response.status === 200) {
            setSearchResults(response.data);
          }
        } catch (error) {
          console.error("Error fetching suggestions:", error);
        }
      }
    }, 300),
    [inputValue]
  );

  useEffect(() => {
    fetchMedicationSuggestions();
    return () => fetchMedicationSuggestions.cancel();
  }, [inputValue, fetchMedicationSuggestions]);

  const submit = async () => {
    setIsSubmitting(true);
    try {
      const response = await api.post(
        `/v1/${practiseid}/patient/${appointmentInfo.patientid}/orders/lcpt-procedure/insert`,
        {
          // icd_sugg: selectedDx,

          patient_id: appointmentInfo.patientid,
          patient_name: `${appointmentInfo.firstname || ""} ${
            appointmentInfo.lastname || ""
          }`.trim(),
          order_id: modalContent.id,
          autosel: "todayList",
          tov: tovValue,
          lov: lovValue,
          diagnosis: selecteddesc,
          ordertype: "procedure",
          ordername: modalContent.content,
          snomed_icd: selectedDx,
          schedule: selectedCard,
          provider: appointmentInfo?.providername,
          status: "CREATED",
          confirm_status: "E",
          user_role: "",
          orderdate:
            dt && dt.includes(" ") && !isNaN(Date.parse(dt.split(" ")[0]))
              ? dt.split(" ")[0]
              : new Date().toISOString().split("T")[0],
          encounterid: 0,
          department_id: appointmentInfo?.departmentid,
        }
      );
      if (response.status === 200) {
        fetchsuggestions();
        setIsModalOpen(false); // Close the modal on success
      }
    } catch (error) {
      console.error("Error submitting data:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleTabClickInhouse = async (itemContent) => {
    const isSelected = selectedTabs.includes(itemContent);
    const orderType = ["STREP TEST", "FLU TEST", "COVID TEST"].includes(
      itemContent
    )
      ? "Diagnostic test"
      : "labs";
    try {
      if (isSelected) {
        // Call delete API
        const orderToDelete = RelatedResults.find(
          (x) => x.ordername === itemContent
        );
        if (orderToDelete) {
          const deleteResponse = await api.delete(
            `/v1/${practiseid}/orders/delete/order/${orderToDelete.ordre_id}`,
            {
              data: {
                // orderdate:  userdata.created_at?new Date(userdata.created_at).toISOString().split('T')[0]: "Invalid date",
                orderdate:
                  dt && dt.includes(" ") && !isNaN(Date.parse(dt.split(" ")[0]))
                    ? dt.split(" ")[0]
                    : new Date().toISOString().split("T")[0],
              },
            }
          );
          console.log("Delete API Response:", deleteResponse.data);
        } else {
          console.error("Order ID not found for deletion");
        }
      } else {
        const createResponse = await api.post(
          `/v1/${practiseid}/patient/${userdata.patientid}/orders/create`,
          {
            department_id: 1,
            patient_name: `${userdata.firstname || ""} ${
              userdata.lastname || ""
            }`.trim(),
            tov: tovValue, // purpose
            lov: userdata.lov,
            diagnosis: "",
            ordertype: orderType, // tabs
            ordername: itemContent, // buttons
            schedule: selectedCard, // t/f-schedule
            // provider: userdata.linked_provider,
            provider: `${userConfig?.firstname || ""} ${userConfig?.lastname || ""}`,
            status: "CREATED",
            confirm_status: "E", // C/E
            orderdate:
              dt && dt.includes(" ") && !isNaN(Date.parse(dt.split(" ")[0]))
                ? dt.split(" ")[0]
                : new Date().toISOString().split("T")[0],
            encounterid: 0,
          }
        );
      }

      // Update state after the API call
      setSelectedTabs((prevSelected) => {
        if (isSelected) {
          // Deselect if already selected
          return prevSelected.filter((content) => content !== itemContent);
        } else {
          // Select if not already selected
          return [...prevSelected, itemContent];
        }
      });
      fetchsuggestions();
    } catch (error) {
      console.error("Error in handleTabClick:", error);
    }
  };

  let isLoadingInHouseLabs = false; // This will track whether the function is already running
   const inHouseLabsContent = [
      "CBC",
      "A1C",
      "CMP",
      "LIPIDS",
      "MAGNESIUM",
      "URIC ACID",
      "THYROID PANEL",
      "VIT D",
      "VIT B12",
      "TESTO",
    ];
  const handleInHouseLabsClick = async () => {
    if (isLoadingInHouseLabs) return; // Prevent double-clicking if already loading
    isLoadingInHouseLabs = true; // Set loading to true to prevent further invocations

 
    try {
      // Filter out the items that are already in selectedTabs
      const itemsToAdd = inHouseLabsContent.filter(
        (content) =>
          !selectedTabs.includes(content) &&
          !getordersData?.look.some((item) => item.ordername === content)
      );

      if (itemsToAdd.length > 0) {
        // Call handleTabClick for all items that are not in selectedTabs in parallel
        await Promise.all(
          itemsToAdd.map((content) => handleTabClickInhouse(content))
        );

        // Update selectedTabs with the newly added items
        selectedTabs.push(...itemsToAdd);
      }
    } catch (error) {
      console.error("Error in handleInHouseLabsClick:", error);
    } finally {
      isLoadingInHouseLabs = false; // Reset the loading state after the operation is complete
    }
  };

  let isLoading = false; // This will track whether the function is already running
 const stripfluContent = ["STREP TEST", "FLU TEST", "COVID TEST"];

  const handleStrepFluCovidClick = async () => {
    if (isLoading) return; // Prevent double-clicking if already loading
    isLoading = true; // Set loading to true to prevent further invocations

   
    try {
      // First, filter out the items that are already in selectedTabs or selectedSuggestionList
      const itemsToAdd = stripfluContent.filter(
        (content) =>
          !selectedTabs.includes(content) &&
          !getordersData?.look.some((item) => item.ordername === content)
      );

      if (itemsToAdd.length > 0) {
        // Call handleTabClick for all items that are not in selectedTabs or selectedSuggestionList in parallel
        await Promise.all(
          itemsToAdd.map((content) => handleTabClickInhouse(content))
        );
      }
    } catch (error) {
      console.error("Error in handleStrepFluCovidClick:", error);
    } finally {
      isLoading = false; // Reset the loading state after the operation is complete
    }
  };

  return (
    <div>
      {!!selectedAddTabs && (
        <div className="flex px-16 flex-wrap justify-start mb-3">
          {data
            .filter(
              (x) =>
                x.content !== "INHOUSE LABS-MALE" &&
                x.content !== "INHOUSE LABS-FEMALE"&& !fav.includes(x.content)
            )
            .map((item) => (
              <div
                  onClick={() => updateFavLabs(item.content)}
                key={item.content}
                className={`cursor-pointer text-[11px] gap-1  font-inter tracking-tigh text-center rounded-[10px] border-[1.5px] border-[#E5E7EB] flex items-center justify-center transition-colors duration-300 ease-in-out bg-white text-[#1D2951 hover:!bg-[#E17954] hover:text-white px-2 h-[33px]`}
                style={{ margin: "8px" }}
              >
                {heartIcon}
                {item.content}
              </div>
            ))}
        </div>
      )}
      <div className="flex items-center px-20 mb-1">
        {starIcon}
        <div className="font-Font1 text-[#1E2A4A] ml-1 font-inter  text-left">
          Favorites
        </div>

        {/* <div
          onClick={handleInHouseLabsClick}
          className={`cursor-pointer text-[12px] mx-1 my-1 font-Font1 font-semibold tracking-tight text-center rounded-[10px] border-[1.5px] border-gray-200 flex items-center justify-center transition-colors duration-300 ease-in-out 
    text-[#374151] bg-white hover:!bg-[#E17954] hover:text-white px-3 h-[30px] 
    ${
      inHouseLabsContent.every((test) =>
        selectedSuggestionList.some((item) => item.ordername === test)
      )
        ? "bg-[#E17954] text-white"
        : ""
    }`}
        > */}
        {/* <div
  onClick={handleInHouseLabsClick}
  className={`cursor-pointer text-[12px] mx-1 my-1 font-Font1 font-semibold tracking-tight text-center rounded-[10px] border-[1.5px] border-gray-200 flex items-center justify-center transition-colors duration-300 ease-in-out px-3 h-[30px]
    ${
      inHouseLabsContent.every((test) =>
        selectedSuggestionList.some((item) => item.ordername === test)
      )
        ? "bg-[#E17954] text-white"
        : "bg-white text-[#374151] hover:!bg-[#E17954] hover:text-white"
    }`}
>
          <img src={SaveIcon} style={{ marginRight: "5px" }} alt="&/" />
          INHOUSE LABS
        </div>

     
        <div
  onClick={handleStrepFluCovidClick}
  className={`cursor-pointer text-[12px] mx-1 my-1 font-Font1 font-semibold tracking-tight text-center rounded-[10px] border-[1.5px] border-gray-200 flex items-center justify-center transition-colors duration-300 ease-in-out px-3 h-[30px]
    ${
      stripfluContent.some((test) =>
        selectedSuggestionList.some((item) => item.ordername === test)
      )
        ? "bg-[#E17954] text-white"
        : "bg-white text-[#374151] hover:!bg-[#E17954] hover:text-white"
    }`}
>
          <img src={SaveIcon} style={{ marginRight: "5px" }} alt="&/" />
          Strep/flu/Covid
        </div> */}
         <div className="flex ml-2 flex-wrap justify-start gap-2">
{fav.map((lab) => {
  const isSelected = selectedTabs.includes(lab);

  return (
    <div
      key={lab}
      onClick={() => handlebuttonclick(lab)}
      className={`${
        isSelected ? 'bg-[#E17954] text-white border-[#E17954]' : 'bg-white text-[#374151] border-[#E5E7EB]'
      } hover:!bg-[#E17954] hover:text-white cursor-pointer text-[12px] mx-1 my-1 font-Font1 font-semibold tracking-tight text-center rounded-[10px] flex items-center justify-center transition-colors duration-300 ease-in-out px-3 h-[30px]`}
    >
      <span className="mr-1">{lab}</span>
      <span
        className="text-[#9CA3AF] hover:text-white font-bold ml-1 cursor-pointer"
        onClick={(e) => {
          e.stopPropagation(); // Prevent parent div click
        removeFavbutton(lab);
        }}
      >
        ×
      </span>
    </div>
  );
})}



</div>
          <button
                              className="focus:outline-none relative group"
                                    onClick={() => setSelectedAddTabs((prev) => !prev)}
                                  >
                                    <div
                                      className={`transition-transform duration-300 ease-in-out ${
                                        selectedAddTabs
                                          ? "rotate-45 text-red-500"
                                          : "rotate-0 text-[#E17954]"
                                      }`}
                                    >
                                      {addIcon}
                                    </div>
                                      {/* Tooltip */}
        <span className="absolute top-[40px] left-1/2 -translate-x-1/2 bg-[#1D2951] text-white text-xs font-medium py-1 px-2 rounded-md opacity-0 group-hover:opacity-100 transition-all duration-200 whitespace-nowrap pointer-events-none z-50">
          Add Favourites
        </span>
                                  </button>
      </div>
      <div className="flex w-full items-center justify-center flex-wrap gap-2">
        {loading && (
          Array.from({ length: 3 }).map((_, index) => (
            <Skeleton
              key={index}
              variant="rectangular"
              width={100}
              height={35}
              style={{ margin: "8px", borderRadius: "50px" }}
            />
          ))
        ) }
      </div>
      <div className="flex w-full items-center justify-start px-20 flex-wrap gap-2">
        {!loading && data.length > 0 ? (
          data.map((item, index) => (
            <div
              key={index}
              onClick={() => handleTabClick(item.content)}
              className={`cursor-pointer text-xs  my-1 font-poppins tracking-tight font-thin text-center rounded-[10px] border-[1.5px] border-gray-200 py-2 flex items-center justify-center transition-colors duration-300 ease-in-out ${
                selectedTabs.includes(item.content)
                  ? "bg-[#e17954] text-white"
                  : "bg-white text-[#1E2A4A]"
              } px-3 hover:!bg-[#E17954] hover:text-white`}
            >
              {item.content}
            </div>
          ))
        ) : (
          <p className="text-center text-gray-500">No suggestions found</p>
        )}
      </div>

      {/* <Dialog open={isModalOpen} onClose={handleClose} maxWidth="sm" fullWidth>
                <DialogContent>
                    <div className="flex justify-between items-center">
                        <h2 className="text-lg font-medium">{modalContent.content}</h2>
                        <IconButton onClick={handleClose}>
                            <CloseIcon />
                        </IconButton>
                    </div>
                    <div className="relative w-full max-w-md ">
                        <FontAwesomeIcon
                            icon={faSearch}
                            className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"
                        />
                        <input
                            type="text"
                            className="rounded-[15px] w-[100%] border border-[#D5D5D5] bg-[#F5F6FA] pl-10 pr-16 py-1 text-base outline-none"
                            placeholder="Search here"
                            value={inputValue}
                            onChange={(e) => {
                                setInputValue(e.target.value);
                                setIsChecked(false);
                            }}
                        />
                    </div>
                    {searchResults && !isChecked && searchResults.length > 0 && (
                        <ul className="mt-2 w-full border rounded-xl">
                            {searchResults.map((suggestion, index) => (
                                <li
                                    key={index}
                                    onClick={() => {
                                        setInputValue(suggestion.condition_name);
                                        setSelectedDx(suggestion.condition_name);
                                        setSelecteddesc(suggestion.condition_name)
                                        setIsChecked(true);
                                    }}
                                    className="p-2 hover:bg-gray-200 text-xs cursor-pointer"
                                >
                                    {suggestion.condition_name}
                                </li>
                            ))}
                        </ul>
                    )}
                    {fetcheddata.length > 0 && (<>
                    <div className='mt-4 text-sm'>Most Used DX</div>
                        <div className="mt-2 flex flex-wrap gap-2">
                            
                            {fetchingDx ? (
                                Array.from({ length: 3 }).map((_, index) => (
                                    <Skeleton
                                        key={index}
                                        variant="rectangular"
                                        width={100}
                                        height={25}
                                        style={{ margin: '8px', borderRadius: '50px' }}
                                    />
                                ))
                            ) : (
                                fetcheddata.map((item, index) => (
                                    <div
                                        key={index}
                                        onClick={() => {
                                            setInputValue('');
                                            setSelectedDx(item.icd10);
                                            setSelecteddesc(item.description)
                                        }}
                                        className={`cursor-pointer text-xs font-poppins py-2 tracking-tight font-thin text-center rounded-full border-[1.5px] border-gray-200 flex items-center justify-center transition-colors duration-300 ease-in-out ${
                                            selectedDx === item.icd10
                                                ? 'bg-[#e17954] text-white'
                                                : 'bg-white text-[#1D2951]'
                                        } px-3 `}
                                        style={{ margin: '1px' }}
                                    >
                                        {item.description}
                                    </div>
                                ))
                            )}
                        </div>
                   </> )}
                    <div className="w-full flex justify-center mt-2">
                        <button
                            onClick={() => submit()}
                            disabled={isSubmitting}
                            className={`rounded py-2 px-12 mt-4 text-sm transition duration-300 ease-in-out shadow-[0px_4px_4px_#00000040] ${
                                isSubmitting ? 'bg-gray-400 cursor-not-allowed' : 'bg-[black] text-[#FFFFFF]'
                            }`}
                        >
                            {isSubmitting ? 'Submitting...' : 'Continue'}
                        </button>
                    </div>
                </DialogContent>
            </Dialog> */}
    </div>
  );
};

// Debounce utility function
function debounce(func, wait) {
  let timeout;
  const debounced = (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => func(...args), wait);
  };
  debounced.cancel = () => clearTimeout(timeout);
  return debounced;
}
export default ProceduresNavButtons;
